module.exports = __webpack_public_path__ + "img/resized-APP-0001-1.e2dd078a.png";